export default __webpack_public_path__ + "static/media/misc-drawerA-768w.99689158.webp";